import { Card } from 'antd';
import { StyledModal } from './styles';

export const TeacherTalkingPointsModal = ({ open, onClose }) => (
  <StyledModal width="80%" title="Teacher Talking Points" footer={null} open={open} onCancel={onClose}>
    <Card className="mt-16" size="small" title="INTRODUCTION">
      <p>Simpolicon:</p>
      <ul>
        <li>“sim” for simulation</li>
        <li>“poli” for political</li>
        <li>“con” for economics</li>
        <li>cloud based simulation of sustainable development</li>
      </ul>
      <p>What Simpolicon teaches:</p>
      <ul>
        <li>History</li>
        <li>Values Clarification</li>
        <li>Insight and Empathy</li>
        <li>Technical components of national development</li>
        <li>Leadership</li>
        <li>Critical Thinking</li>
        <li>Decision-Making Skills</li>
        <li>International Relations</li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="HISTORY">
      <p>
        In World War Two, the Allies fought German empire but maintained their own empires. Allies fought Aryan superiority but Allies
        maintained colored colonies.
        <br />
        Allies preached democracy, nationalism, and self-determination but didn’t allow democracy in their colonial
        empires. Colonies fought on behalf of their rulers, and then fought for their own independence.
      </p>
      <p>Independence timeline:</p>
      <ul>
        <li>Philippines (USA 1946)</li>
        <li>India and Pakistan (Great Britain, 1947)</li>
        <li>Israel (Great Britain, 1948)</li>
        <li>Indonesia (The Netherlands, 1949)</li>
        <li>Federation of Malaya, Ghana (Great Britain, 1957)</li>
        <li>Zaire (Belgium, 1960)</li>
        <li>Algeria (France, 1962)</li>
        <li>Kenya (Great Britain, 1963)</li>
        <li>Singapore (Great Britain &amp; Malaya, 1965)</li>
        <li>Bangladesh (Pakistan, 1971)</li>
        <li>Angola (Portugal, 1975)</li>
        <li>Armenia, Azerbaijan, Belarus, Estonia, Georgia, Kazakhstan, Kyrgyzstan, Latvia,</li>
        <li>Lithuania, Moldova, Tajikistan, Turkmenistan, Ukraine, Uzbekistan (USSR, 1985-1991)</li>
        <li>Slovenia, and Croatia (Yugoslavia, 1991)</li>
        <li>Macedonia, Bosnia &amp; Herzegovina, Serbia, Montenegro (Yugoslavia, 1992)</li>
        <li>South Sudan (Sudan, 2011)</li>
      </ul>
      <p>Development problems are some of the defining images of the 20 th and 21 st centuries.</p>
      <p>
        How do you balance economic growth, pollution, resource conservation, population, international trade, and world
        peace?
      </p>
      <p>
        Remember your overall goal: to create the best sustainable Standard of Living for your country and the world.
        How can that be measured?
      </p>
    </Card>
    <Card className="mt-16" size="small" title="GETTING STARTED">
      <p>Log in with your user name and password.</p>
      <p>The Dashboard along the left edge:</p>
      <ul>
        <li>World Briefing: All countries: data can be sorted ascending or descending</li>
        <li>National Briefing: Your country in detail</li>
        <li>Goals: Your country’s priorities; weighted values times production -{'>'} score</li>
        <li>Production: Category, Product, Process, Factor (Basic, and Optional)</li>
        <li>Trade: Request or Offer items for trade; need for Gold to trade</li>
        <li>Population: Nutrition, Reproduction, Migration</li>
        <li>Military: Overview, Rules</li>
        <li>Feed the People /End the Year, wait to start a new year</li>
      </ul>
      <p>Get acquainted with your country’s population and resources.</p>
    </Card>
    <Card className="mt-16" size="small" title="GOALS AND WEIGHTINGS">
      <p>
        Set national priorities based on your values and priorities
        <br />
        Your goal is to create the best sustainable Standard of Living for your country and the world. How can that be
        measured?
      </p>
      <p>Goals: Go over Goals and setting a country’s priorities and how they influence the score.</p>
      <table>
        <tr>
          <td>Goal Ranking</td>
          <td>Goal Name</td>
          <td>Points</td>
          <td>Weight</td>
          <td>Score*</td>
        </tr>
        <tr>
          <td>1</td>
          <td>Develop Agriculture</td>
          <td>50</td>
          <td>12</td>
          <td>12 x 50 = 600</td>
        </tr>
        <tr>
          <td>2</td>
          <td>Develop Education</td>
          <td>50</td>
          <td>11</td>
          <td>11 x 50 = 550</td>
        </tr>
        <tr>
          <td>3</td>
          <td>XXX</td>
          <td>50</td>
          <td>10</td>
          <td>10 x 50 = 500</td>
        </tr>
        <tr>
          <td>4</td>
          <td>YYY</td>
          <td>50</td>
          <td>9</td>
          <td>9 x 50 = 450</td>
        </tr>
        <tr>
          <td>5</td>
          <td>ZZZ</td>
          <td>50</td>
          <td>8</td>
          <td>8 x 50 = 400</td>
        </tr>
        <tr>
          <td>6</td>
          <td>AAA</td>
          <td>50</td>
          <td>7</td>
          <td>7 x 50 = 350</td>
        </tr>
        <tr>
          <td>7</td>
          <td>BBB</td>
          <td>50</td>
          <td>6</td>
          <td>6 x 50 = 300</td>
        </tr>
        <tr>
          <td>8</td>
          <td>CCC</td>
          <td>50</td>
          <td>5</td>
          <td>5 x 50 = 250</td>
        </tr>
        <tr>
          <td>9</td>
          <td>DDD</td>
          <td>50</td>
          <td>4</td>
          <td>4 x 50 = 200</td>
        </tr>
        <tr>
          <td>10</td>
          <td>EEE</td>
          <td>50</td>
          <td>3</td>
          <td>3 x 50 = 150</td>
        </tr>
        <tr>
          <td>11</td>
          <td>FFF</td>
          <td>50</td>
          <td>2</td>
          <td>2 x 50 = 100</td>
        </tr>
        <tr>
          <td>12</td>
          <td>Develop Health Services</td>
          <td>50</td>
          <td>1</td>
          <td>1 x 50 = 50</td>
        </tr>
        <tr>
          <td colSpan={5} style={{ textAlign: 'right' }}>
            TOTAL SCORE = 3850
          </td>
        </tr>
      </table>
      <p>*Three categories generate a negative score (net pollution, consumption of natural resources, and deaths)</p>
    </Card>
    <Card className="mt-16" size="small" title="THE WORLD AS IT IS">
      <p>
        The world as it is, versus the world the way you want it to be.
        <br />
        State of the Village Report (2009)
        <br />
        Source: www.odt.org/pop.hm, Donella H Meadows; data needs to be updated!!!
      </p>
      <p>IF the world were a village of only 100 people, there would be:</p>
      <ul>
        <li>60 Asians</li>
        <li>14 Africans</li>
        <li>12 Europeans</li>
        <li>8 people from Central and South America, Mexico and the Caribbean</li>
        <li>5 people from the US and Canada</li>
        <li>1 person from Australia or New Zealand</li>
      </ul>
      <p>The people of the village would have considerable difficulty communicating:</p>
      <ul>
        <li>14 would speak Mandarin</li>
        <li>8 would speak Hindu/Urdu</li>
        <li>8 English</li>
        <li>7 Spanish</li>
        <li>4 Russian</li>
        <li>7 Arabic</li>
      </ul>
      <p>
        This list accounts for only 45 of the 100 villagers. The others speak Bengali, Portuguese, Indonesian, Japanese,
        German, French, and 200 other languages.
      </p>
      <p>In the village there would be:</p>
      <ul>
        <li>33 Christians</li>
        <li>22 Muslims</li>
        <li>15 Hindus</li>
        <li>14 Non-religious, Agnostics, or Atheists</li>
        <li>6 Buddhists</li>
        <li>10 All other religious (including Judaism 0.2%)</li>
      </ul>
      <p>In this 100-person community:</p>
      <ul>
        <li>80 would live in substandard housing</li>
        <li>67 adults would live in the village and half of them would be illiterate</li>
        <li>50 would suffer from malnutrition</li>
        <li>33 would not have access to clean, safe drinking water</li>
        <li>
          24 would not have electricity of the 76 that do have electricity, most would use it only for light at night
        </li>
        <li>
          In the village would be 42 radios, 24 televisions, 14 telephones, and 7 computers (some villagers own more
          than one of each)
        </li>
        <li>7 people would own an automobile (some of them more than one)</li>
        <li>
          5 people would possess 32% of the entire village’s wealth, and they would all be from USA. The poorest 1/3
          would receive only 3% of the income of the village.
        </li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="PRODUCTION">
      <p>
        Begin production (see Quick Start tab in student countries), trade with other countries, feed your people, end
        the year, analyze your results, and make (new) decisions.
      </p>
      <p>
        How do the resources and skills you have affect your decisions, especially in terms of labor and/or land
        intensive production?
      </p>
    </Card>
    <Card className="mt-16" size="small" title="BASIC ECONOMICS">
      <p>(Greek “oikonomia” household management)</p>
      <p>It’s a Social Science</p>
      <ul>
        <li>Social: people, value judgments</li>
        <li>Science: empirical, factual, data</li>
      </ul>
      <p>Deals with production and distribution of goods and services</p>
      <p>Premise:</p>
      <ul>
        <li>Wants &gt; Needs</li>
        <li>Demand &gt; Supply</li>
        <p>Therefore: must make choices</p>
        <p>Choices = Opportunity Costs (what you give up to do something else)</p>
        <ul>
          <li>Individual level: how to spend your $, your time, your effort</li>
          <li>
            National level: how to manage natural resources for greatest good
            <ul>
              <li>Steel: weapons or consumer good?</li>
              <li>Lumber: Clinics or schools?</li>
              <li>Skilled Labor: Engineer, Ecologists, Philanthropist?</li>
            </ul>
          </li>
          <li>
            International Level
            <ul>
              <li>Health or Education? (an endless list)</li>
              <li>Aid $ (where do the $ come from?)</li>
            </ul>
          </li>
          <li>
            UN Declaration of Human Rights (30 Articles)
            <ul>
              <li>
                “Everyone has a right to …. An adequate standard of living, to an education, to work, to global peace
                and security
              </li>
            </ul>
          </li>
        </ul>
      </ul>
      <p>Priorities</p>
      <ul>
        <p>
          Economic growth, full employment, price stability, economic freedom, equitable distribution, economic
          security, conservation, others?
          <br />
          Are these mutually exclusive?
        </p>
        <p>Production Challenges and Solutions</p>
        <li>Lack of natural resources {'->'} use International trade</li>
        <li>Lack of products {'->'} increase production, renew land, trade</li>
        <li>Lack of personnel {'->'} build schools, educate your people, encourage immigration</li>
        <li>Births &amp; deaths {'->'} improve health care, manage growth rate, provide adequate nutrition</li>
        <li>Pollution {'->'} use pollution control devices, clean up</li>
        <li>Natural disasters {'->'} plan ahead</li>
      </ul>
      <p>See Quick Start tab in the heading of any student country.</p>
      <p>Explain “Factor” values, GDP, National Wealth</p>
      <p>
        Go over “Summary of the process” for producing fish more efficiently using Small Machines, but Small Machines
        require Steel and Semi-skilled labor Steel requires Coal and Iron from Coal and Iron Deposits which you mine or
        trade for, Semi-Skilled Labor requires a Primary School which requires Lumber to build it, Finally you have a
        Small Machine to grow and harvest rice more efficiently.
      </p>
      <p>Production Tips (see also “Hints” tab in the heading of any student country.)</p>
      <ul>
        <li>Land (may be renewed)</li>
        <li>Mineral deposits (cannot be renewed)</li>
        <li>People (annual and lifetime limits)</li>
        <li>Facilities and Equipment (annual and lifetime limits)</li>
        <li>Education doesn’t create “new people,” it simply puts them into a new category</li>
        <li>Retired and Dependent people (new born) do not work but still need to be fed</li>
        <li>Pollution is easier to prevent than to clean up</li>
        <li>“Systems” are good—they multiply your production output (and your pollution)</li>
        <li>Mistakes Happen—continue to play—mistakes occur in the real world, too</li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="TRADE">
      <ul>
        <li>Trade requires Gold.</li>
        <li>Items are always “new” items</li>
        <li>You cannot trade Land or Mineral Deposits</li>
        <li>You cannot trade anything that is “attached” to the ground (e.g., schools, hospitals)</li>
        <li>Immigration and Emigration: all people can migrate</li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="UNDERSTANDING AND INTERACTING WITH OTHERS">
      <p>
        If you were to parachute into another country, try to identify their institutions and features to try to
        understand their point of view. What are their points of contacts with other countries (politics, religion,
        economics) and what are their internal institutions and values that hold them together (family and education).
      </p>
      <p>Identify their major institutions: Family, Education, Religion, Economics, Government.</p>
      <p>
        Identify their other universal features: Language, Tools, Age &amp; Gender Differentiation, Prestige or Status
        Hierarchies, Recreation or Play, Art.
      </p>
      <p>Now that you “know” them, how will you interact with them?</p>
      <p>Carl Sagan’s Rules to Consider:</p>
      <ul>
        <li>Golden Rule: Do unto others as you would have them do unto you</li>
        <li>Silver Rule: Do not do unto others, what you would not want them to do unto you</li>
        <li>Bronze or Brazen Rule: Do unto others as they do unto you (an eye for an eye)</li>
        <li>Iron Rule: Do unto others as you like before they do it to you</li>
        <li>Tin Rule: Golden Rule for those above you and Iron Rule for those below you</li>
        <li>Nepotism Rule: Give precedence to relatives or friends, and do as you like to others</li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="MORE BASIC ECONOMICS:">
      <p>Points of view: remember economics is a social science.</p>
      <ul>
        <li>Presentation (statistics, propaganda, “Spin”)</li>
        <li>Did you know there are three ways to calculate “average”?</li>
        <li>Mean, Median, Mode</li>
        <p></p>
        <li>13+13+13+13+14+14+16+18+21= 135</li>
        <p></p>
        <li>15 Is the “mean” 135 / 9</li>
        <li>14 is the “median” right in the middle of the sequence</li>
        <li>13 is the “mode” the number that appears most frequently</li>
      </ul>
      <p>Thus, the same numbers produce three different answers for the word “average”</p>
      <p>A few simple questions:</p>
      <ul>
        <li>What to produce?</li>
        <li>How much to produce?</li>
        <li>Who produces it and how?</li>
        <li>Who gets the product?</li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="POLITICAL – ECONOMIC GRID">
      <p>Answers depend on:</p>
      <ul>
        <li>1. Factors of Production: Land, Labor, Capital (equipment), Management (entrepreneurship)</li>
        <li>2. Economic/Political/Philosophic Outlook:</li>
        <p>
          Economic Spectrum scale: Market, Planned, Traditional (rare), Mixed Ownership scale, competition scale, gov’t
          involvement scale, tax and spending scale
        </p>
        <p>
          Political Spectrum scale: Democracy to Totalitarianism Respect scale, power scale, economic distribution
          scale, information scale Anarchy, pure democracy, representative democracy, pseudo democracy, plutocracy,
          kleptocracy, meritocracy, bureaucracy, aristocracy, oligarchy, gerontocracy, theocracy, monarchy, patriarchy,
          matriarchy, autocracy.
        </p>
        <p>Economic Spectrum and Political Spectrum scales combined (a simplification)</p>
        <p>
          Democracy and Market = Capitalism
          <br />
          Democracy and Planned = Socialism
          <br />
          Totalitarianism and Market = Fascism
          <br />
          Totalitarianism and Planned = Communism
        </p>
        <p>
          You can see how countries rank politically and economically by googling various websites for Freedom in the
          World, Free Press, Economic Freedom, etc. The counties can then be placed on the grid for that particular
          point in time. Countries will move around in the grid depending on current politics and administrations.
        </p>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="LEADERSHIP">
      <p>What's the definition of a Leader?</p>
      <ul>
        <li>Someone people follow willingly</li>
        <ul>
          Depends on the culture (e.g., Japan vs, USA)
          <li>Japan: consensus, harmony, cooperation, avoid friction</li>
          <li>USA: Individualism, competition, compromise, majority rule</li>
        </ul>
        <li>Has clear goals</li>
        <li>Has a vision of success</li>
        <li>Inspires hope</li>
        <li>Creates solutions</li>
        <li>Has imagination</li>
        <li>Is clear thinking</li>
        <li>Is practical or charismatic</li>
        <li>Understands her/his followers</li>
        <li>Has stamina</li>
        <li>Has self-confidence and courage</li>
      </ul>
      <p>A great leader has:</p>
      <ul>
        <li>Ethos: moral character, is source of being able to persuade</li>
        <li>Pathos: the ability to touch feelings, to move people emotionally</li>
        <li>Logos: the ability to give solid reasons for an action, to move people intellectually</li>
      </ul>
      <p>Good followers:</p>
      <ul>
        <li>Are involved in the issues</li>
        <li>Are attentive to the details</li>
        <li>Are active in the process</li>
        <li>Are not blindly obedient</li>
        <li>Don’t abdicate responsibility</li>
        <li>Avoid clichés and platitudes</li>
      </ul>
      <p>Leaders and Followers bound by trust</p>
      <ul>
        <li>
          Leaders {'->'} trust {'--<'} Followers
        </li>
        <li>
          Where does trust come from?
          <ul>
            <li>Honesty. Tell the truth. Don’t use lies to reach your goals faster</li>
            <li>Candor. Tell it like it is. Be honest and open</li>
            <li>Transparency. Don’t keep secrets or operate with hidden agendas.</li>
            <li>Good judgment. Make decisions that are based on sound advice and reasoning</li>
            <li>Good judgment comes from experience and experience comes from bad judgment.</li>
          </ul>
        </li>
        <li>
          How to become a good follower and a great leader:
          <ul>
            <li>
              Get a good education: listen diligently, ask questions, seek answers, and learn how to clearly express
              your ideas
            </li>
          </ul>
        </li>
        <li>
          Get a broad education:
          <ul>
            <li>A wide variety of subjects;</li>
            <li>A variety of ways and methods of thinking and analyzing;</li>
            <li>A sense of mastery of at least one subject</li>
            <li>Learn by discussion with others</li>
            <li>Listen to what others are saying;</li>
            <li>Be able to reflect what others have shared</li>
            <li>Learn by doing: participate, volunteer, get involved</li>
          </ul>
        </li>
        <li>
          You will gain a sense of:
          <ul>
            <li>Place: cultural history and identity</li>
            <li>Self: insight into humanity and its condition; and</li>
            <li>Judgment: a basis for deciding what is proper, worthy, and noble</li>
          </ul>
        </li>
        <li>
          You will be able to:
          <ul>
            <li>See things you wouldn’t have seen</li>
            <li>Understand things you wouldn’t have understood</li>
            <li>Think things you wouldn’t have thought</li>
            <li>See problems, possibilities, and solutions</li>
          </ul>
        </li>
        <li>
          You will:
          <ul>
            <li>Be concerned with the quality of life of the society as a whole</li>
            <li>Contribute to the quality and direction of a civilized and humane world</li>
            <li>Be a good follower and</li>
            <li>Be a great leader</li>
          </ul>
        </li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="THE PEOPLE: DEMOGRAPHICS">
      <p>Demography and demographics</p>
      <p>Basic population dynamics:</p>
      <ul>
        <li>The “natural birth rate” for 1000 people is 45 births per year</li>
        <li>The “natural death rate” for 1000 people is 35 deaths per year</li>
        <br />
        <li>Population = 1000</li>
        <li>Year 1 births 45</li>
        <li>Year 1 deaths 35</li>
        <li>Population at the end of year 1 = 1010</li>
        <li>The net growth rate 1010 - 1000 = 10 = 1000 so growth rate in year 1 = 1%</li>
        <li>1% growth rate: No Problem!</li>
        <br />
        <li>But wait . . . there’s The Rule of 72</li>
        <li>Take any % and divide into 72 and you’ll get the approximate doubling time</li>
        <li>A 1 % growth rate will double in 72 years</li>
        <li>A 5 % growth rate will double in only 14 years</li>
        <li>A 10% growth rate will double in only 7 years</li>
      </ul>
      <p>
        In the year 15 A.D. China had a population of approximately 70,000,000
        <br />
        2000 years divided by 72 = 28 doublings (rounded)
      </p>
      <ul>
        <li>70 million x 2 = 140 million</li>
        <li>140 million x 2 = 280 million</li>
        <li>280 million x 2 = 560 million</li>
        <li>And so forth, 25 more times . . .</li>
        <li>China by 2015 would have a population of 18,000,000,000,000,000</li>
        <li>Current world population only 8,000,000,000+</li>
        <li>
          Other examples: using a 1 inch thick newspaper, fold it in half so it becomes 2 inches thick. How many times
          would you have to fold it to reach the sun 93 million miles away? (Only 44 times.)
        </li>
        <li>
          Choice: receive $1,000,000 a day for life or receive $0.01 today and double it very day. Which would give you
          more money? (n 28 days you’d have 28,000,000 or 1 cent today, 2 cents tomorrow, 4 cents the next day, … 1.3
          million on day 28 day alone.)
        </li>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="LIFE EXPECTANCY">
      <p>Life Expectancy</p>
      <ul>
        <li>So why isn’t China’s population 18 million billion today? War, Disease, Famine</li>
        <li>Before 1800 smallpox accounted for 5-10 % of all deaths</li>
        <li>In 1796 Dr. Edward Jenner developed the idea of inoculation and life expectancy improved;</li>
        <li>In USA up to 1800 life expectancy was 25-35 years of age. Today it’s about 80 years in some countries.</li>
      </ul>
      <p>Population vs Food Production</p>
      <ul>
        <li>Arithmetic vs geometric growth (Thomas Malthus’s theory 1820)</li>
        <li>1 plot of land with 1 person</li>
        <li>2 plots of land with 2 people</li>
        <li>3 plots of land with 4 people</li>
        <li>Land doesn’t reproduce itself; people do</li>
        <li>4 plots of land, 8 people</li>
        <li>5 plots of land, 16 people</li>
        <li>6 plots of land, 32 people</li>
        <li>Eventually the number of people outstrips production of food</li>
        <li>See data on real world population doubling times.</li>
      </ul>
      <p>Which is easier, lowering birth rates or lowering death rates?</p>
      <p>
        Easier to lower death rates with modern medicine (one vaccination) than it is to lower birth rates which is
        culturally determined and takes on-going effort. Lower death rates reduced the 35 natural death rate to 25, for
        example, but birth rates have stayed high, sometimes close to the 45 natural birth rate. So 45 births per 1000
        less 25 death rate gives growth rate of 20 (not 10) which means a doubling time of 36 years (not 72 years). That
        means doubling the number of schools and hospitals, roads, bridges, etc. just to keep the current standard of
        living.
        <br />
        If GDP growth rate is 1% and population growth rate is 2%, then GDP per capita and Standard of Living goes down.
      </p>
    </Card>
    <Card className="mt-16" size="small" title="STANDARD OF LIVING AND ENVRONMENTAL IMPACT">
      <p>Standard of Living</p>
      <ul>
        The environment sets the upper and lower limits of our Standard of Living.
        <ul>
          Lower limit: food types, disease types
          <li>
            Food types:
            <ul>
              <li>Temperate zones: wheat, corn, oats, barley, rye, millet, wild rice</li>
              <li>Tropical Zones: rice, sugar, bamboo, taro, yam, cassava, banana &amp; plantain</li>
              <li>Tropical zone plants are lower in nutrition and can lead to Kwashiorkor and Marasmus</li>
            </ul>
          </li>
          <li>
            Disease types:
            <ul>
              <li>Malaria</li>
              <li>Schistosomiasis – bilharzia</li>
              <li>Onchocerciasis – river blindness</li>
              <li>Trachoma</li>
              <li>Dracunculiasis (Guinea worm)</li>
            </ul>
          </li>
          <p>Go to Carter Center for more information on these</p>
          <p></p>
          <li>
            Upper Limit: Culture impacts environment
            <ul>
              Standard of Living {'<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<'}
              Food types and diseases {'->'} health {'<-'} {'>=>'} productivity {'-> -<'} education
            </ul>
          </li>
          <li>Lower limit</li>
        </ul>
      </ul>
      <p>How does one measure the impact of population and consumption on the environment?</p>
      <p>
        What is a country’s optimum population? What impact does population growth have on a country and the world? Does
        the population of certain countries have a greater impact on the world than the population of other countries
        especially in terms of resource consumption? What is a minimum standard of living? What does it include?
      </p>
      <p>Environmental Impact = Population x Affluence x Technology</p>
      <ul>
        <p>How do we measure these?</p>
        <p>Population: census</p>
        <p>Affluence: GDP per capita (producer goods, consumer goods, services)</p>
        <p>
          Technology: resources used in production of goods (energy, fertilizer, plastic, carcinogenic particles, ozone
          depleting agents, etc.)
        </p>
        <table>
          <tr>
            <td>Country</td>
            <td>Population</td>
            <td>Affluence</td>
            <td>Technology</td>
            <td>Impact</td>
          </tr>
          <tr>
            <td>USA</td>
            <td>10</td>
            <td>10</td>
            <td>6</td>
            <td>600</td>
          </tr>
          <tr>
            <td>Zambia</td>
            <td>10</td>
            <td>2</td>
            <td>2</td>
            <td>40</td>
          </tr>
          <tr></tr>
          <tr>
            <td>USA</td>
            <td>11</td>
            <td>11</td>
            <td>7</td>
            <td>847</td>
          </tr>
          <tr>
            <td>Zambia</td>
            <td>12</td>
            <td>4</td>
            <td>4</td>
            <td>192</td>
          </tr>
        </table>
      </ul>
    </Card>
    <Card className="mt-16" size="small" title="FEED YOUR PEOPLE AND END THE YEAR">
      <p>Ensure sufficient nutrition for each of your population</p>
      <ul>
        <li>Produce or trade for 50 carbohydrates from Bread or Tubers, AND</li>
        <li>50 proteins from Meat or Fish, AND</li>
        <li>50 units of potable and/or non-potable water</li>
      </ul>
      <p>End the year and analyze your population and production changes.</p>
      <p>Wait for the new year to begin.</p>
    </Card>
    <Card className="mt-16" size="small" title="GENERAL “WHAT IF?” QUESTIONS">
      <p>
        How would the simulation be different if the leader of each county spoke a different language and held different
        religious beliefs?
      </p>
      <p>
        In the simulation, each country was “history-less.” How does having histories affect countries in the real
        world?
      </p>
      <p>
        In the simulation, the world was “geography-less” (no lakes, rivers oceans, deserts, mountains, and so forth).
        How might geography affect economic development and political relationships in the real world?
      </p>
      <p>
        There may have been wars in the simulation. How did the simulated world deal with these conflicts? How is this
        the same or different from how the real world handles these situations?
      </p>
      <p>
        Life and death to our populations, emigration and immigration, changing labor needs, births and retirement all
        affected your decisions and actions in the simulation. What do you think is the ideal population for a country
        and why?
      </p>
      <p>
        What role did foreign aid (gifts of products and/or migration from one county to another) play during the
        simulation? How significant was this aid? Did receiving or giving such aid change your opinion about foreign aid
        in the real world?
      </p>
      <p>
        Discuss the role of international trade in the simulation. Who traded with whom? Why? Were trades fair? Did some
        countries take advantage of others?
      </p>
      <p>What did you learn in the simulation that you would like the real world to know?</p>
      <p>
        How are the various “interest groups” (agriculture, business, consumer protection, education, health, and
        military) interrelated and interdependent?
      </p>
      <p>
        How does a nation resolve the competing claims on its resources by the various interest groups? Which interest
        groups have priority? Do these priorities change over time?
      </p>
      <p>What are the particular problems of one crop economies?</p>
      <p>
        How should national success be measured? GDP counts everything that is made, good or bad. What other ways might
        there be for measuring national success?
      </p>
      <p>What is the impact of one country’s wealth on other nations?</p>
      <p>Is foreign aid good? Should foreign aid have strings attached?</p>
      <p>How should a nation’s quality of life be measured?</p>
      <p>How should a nation balance the need for jobs and production with the need for environmental quality?</p>
    </Card>
  </StyledModal>
);
